export const returnStringsFromArray = (strings: string[]): string => {
  if (typeof strings === "string") {
    return strings;
  }

  let finalString = "";
  let isFirst = true;
  strings.forEach((value) => {
    if (isFirst) {
      finalString += value;
      isFirst = false;
    } else {
      finalString += `,${value}`;
    }
  });

  return finalString;
};

/**
 * Checks if the provided string is empty.
 * @param str - The string to check.
 * @returns true if the string is empty, false otherwise.
 */
export function isEmptyString(str: string): boolean {
  return str.length === 0;
}

/**
 * Checks whether a value is not a usable text string (not a string, or only whitespace).
 * @param value - The value to check.
 * @returns true when the value is missing, not a string, or blank.
 */
export function isBlankString(value: unknown): boolean {
  return typeof value !== "string" || value.trim() === "";
}

export const getValidFileName = (name: string): string => {
  if (!name) return "";
  const fileName: string = name.split(".").slice(0, -1).join(".");
  const normalizedFileName: string = fileName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\//g, "-")
    .replace(/\s/g, "_")
    .replace(/[^a-zA-Z0-9._-]/g, "");
  return normalizedFileName;
};
